<template>
    <article class="view-mode-tabs">
        <fieldset title="Показать плиткой">
            <input
                class="visually-hidden"
                type="radio"
                :name="name"
                id="view-blocks"
                value="view-blocks"
                v-model="value"
                @change="chooseItem"
                checked />
            <label for="view-blocks">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M2 2H11V11H2V2Z" fill="white"/>
                    <path d="M2 13H11V22H2V13Z" fill="white"/>
                    <path d="M13 13H22V22H13V13Z" fill="white"/>
                    <path d="M13 2H22V11H13V2Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 4H4V9H9V4ZM9 15H4V20H9V15ZM20 15H15V20H20V15ZM20 4H15V9H20V4ZM2 2V11H11V2H2ZM2 13V22H11V13H2ZM22 13V22H13V13H22ZM13 2V11H22V2H13Z" fill="white"/>
                </svg>
            </label>
        </fieldset>
        <fieldset v-if="!isMobile && !isTablet" title="Показать списком">
            <input
                class="visually-hidden"
                type="radio"
                :name="name"
                id="view-list"
                value="view-list"
                v-model="value"
                @change="chooseItem"/>
            <label for="view-list">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4C22 4.55228 21.5523 5 21 5H3C2.44772 5 2 4.55228 2 4ZM2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12ZM2 20C2 19.4477 2.44772 19 3 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20Z" fill="white"/>
                </svg>
            </label>
        </fieldset>
        <fieldset title="Показать на карте">
            <input
                class="visually-hidden"
                type="radio"
                :name="name"
                id="view-map"
                value="view-map"
                v-model="value"
                @change="chooseItem"/>
            <label for="view-map">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C12 22 20 15 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 15 12 22 12 22ZM12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z" fill="white"/>
                </svg>
            </label>
        </fieldset>
    </article>
</template>

<script>
    export default {
        name: 'TabsIcons',
        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
            isTablet: {
                type: Boolean,
                default: false
            },
            onloadValue: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                name: 'VIEW_MODE',
                value: 'view-blocks',
            }
        },
        methods: {
            chooseItem () {
                this.$emit('viewModeSelected', this.name, this.value)
            },
        },
        created() {
            if (this.onloadValue) {
                this.value = this.onloadValue
            }
        }
    }
</script>